(() => {
  const selector = '[data-mumuso-career-page]';

  function initializeCareerPage(root) {
    if (root.dataset.careerPageReady === 'true') return;

    const section = root.querySelector('[data-career-motion-section]');
    const mascot = root.querySelector('[data-career-motion-mascot]');
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!section || !mascot) return;

    root.dataset.careerPageReady = 'true';
    let frameId = 0;

    const updateMascot = () => {
      frameId = 0;

      if (!desktopQuery.matches || reducedMotionQuery.matches) {
        mascot.style.setProperty('--career-motion-x', '0px');
        return;
      }

      const rect = section.getBoundingClientRect();
      const scrollRange = window.innerHeight + rect.height;
      const progress = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / scrollRange));
      const travel = Math.min(240, Math.max(130, section.clientWidth * 0.14));
      const offset = (0.5 - progress) * travel;

      mascot.style.setProperty('--career-motion-x', `${offset.toFixed(1)}px`);
    };

    const requestUpdate = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(updateMascot);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    desktopQuery.addEventListener?.('change', requestUpdate);
    reducedMotionQuery.addEventListener?.('change', requestUpdate);
    requestUpdate();
  }

  function initializeAllCareerPages(scope = document) {
    scope.querySelectorAll(selector).forEach(initializeCareerPage);
  }

  initializeAllCareerPages();
  document.addEventListener('shopify:section:load', (event) => initializeAllCareerPages(event.target));
})();
